export const SET_CHECK_PACKAGENAME_RESULT = 'SET_CHECK_PACKAGENAME_RESULT';
export const CAMPAIGN_CHECK_PACKAGENAME = 'CAMPAIGN_CHECK_PACKAGENAME';
export const RECOMMENDED_GAME_LIST_REQUEST = 'RECOMMENDED_GAME_LIST_REQUEST';
export const SET_RECOMMENDED_GAME_LIST = 'SET_RECOMMENDED_GAME_LIST';
export const RECOMMENDED_GAME_DETAIL_REQUEST =
  'RECOMMENDED_GAME_DETAIL_REQUEST';
export const SET_RECOMMENDED_GAME_DETAIL = 'SET_RECOMMENDED_GAME_DETAIL';
export const RECOMMENDED_GAME_CREATE = 'RECOMMENDED_GAME_CREATE';
export const RECOMMENDED_GAME_REMOVE = 'RECOMMENDED_GAME_REMOVE';
export const RECOMMENDED_GAME_LOCK_STATE_UPDATE =
  'RECOMMENDED_GAME_LOCK_STATE_UPDATE';
export const RECOMMENDED_GAME_TERMINATE = 'RECOMMENDED_GAME_TERMINATE';
export const SPECIAL_GAME_LIST_REQUEST = 'SPECIAL_GAME_LIST_REQUEST';
export const SET_SPECIAL_GAME_LIST = 'SET_SPECIAL_GAME_LIST';
export const SPECIAL_GAME_DETAIL_REQUEST = 'SPECIAL_GAME_DETAIL_REQUEST';
export const SET_SPECIAL_GAME_DETAIL = 'SET_SPECIAL_GAME_DETAIL';
export const SPECIAL_GAME_REMOVE = 'SPECIAL_GAME_REMOVE';
export const SPECIAL_GAME_CREATE = 'SPECIAL_GAME_CREATE';
export const SPECIAL_GAME_LOCK_STATE_UPDATE = 'SPECIAL_GAME_LOCK_STATE_UPDATE';
export const SPECIAL_GAME_TERMINATE = 'SPECIAL_GAME_TERMINATE';
export const CAMPAIGN_SORT_UPDATE = 'CAMPAIGN_SORT_UPDATE';
export const SET_CAMPAIGN_PAGINATION = 'SET_CAMPAIGN_PAGINATION';

export const SET_MESSAGE_REQUEST = 'SET_MESSAGE_REQUEST';

export const SET_CAMPAIGN_RESPONSE = 'SET_CAMPAIGN_RESPONSE';

export const SPECIAL_GAME_DEPOSIT_REQUEST = 'SPECIAL_GAME_DEPOSIT_REQUEST';

export const RECOMMENDED_GAME_UPDATE_REQUEST =
  'RECOMMENDED_GAME_UPDATE_REQUEST';

export const SPECIAL_GAME_UPDATE_REQUEST = 'SPECIAL_GAME_UPDATE_REQUEST';
